import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

export class BaseService {
  constructor() { }

  public getHeaders(includeJsonContentType?: boolean): HttpHeaders {
    const header: HttpHeaders = new HttpHeaders()
                                                  .set('Accept', `application/json, text/plain, */*`);
    return header;
  }

  public handleError<T>(operation = 'operation', result?: T){
    return(error: HttpErrorResponse): Observable<T> => {
      return of(result as T);
    };
  }
}
